import { useDishMenuStore } from "../../../../../store/use-dish-menu-store";

export const getMenuId = () => {
  const search = window.location.search;
  if (!search) return undefined;
  const splitted = search.split('&');
  const menuPair = splitted.find((item) => item.includes('menuId'));
  if (!menuPair) return undefined;
  const menuId = menuPair.split('=')[1];
  if (!menuId) return undefined;
  return menuId;
};

export const getCurrentMenu = () => {
  const menuList = useDishMenuStore.getState().menuList;
  if (!menuList) return undefined;
  const menuId = getMenuId();
  if (!menuId) return undefined;
  const menu = menuList.find((item) => item.id === menuId);
  return menu;
};
